var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tabs',_vm._b({staticClass:"d-flex flex flex-column flex-grow-1",attrs:{"show-arrows":"","value":_vm.value},on:{"change":function($event){return _vm.$emit('change',$event)}}},'v-tabs',_vm.$attrs,false),[_vm._t("tab")],2),_vm._t("items")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }